import PropertyDetailsView from "./PropertyDetailsView"
export default PropertyDetailsView
